import { PaymentMethodDTO } from 'core/api';
import { Result, SessionProvider } from 'core/infrastructure';
import { ThemeManager } from 'pos/ui';
import SelectSuggestedTipAmountScreen from './SelectSuggestedTipAmountScreen';
import InsertCustomTipAmountScreen from 'pos/modules/helpers/payments-processing/InsertCustomTipAmountScreen';
import { Modal } from 'core/ui-next/modal';


export default async function getTipData(amountToPay: number, method: PaymentMethodDTO): Promise<Result<number>> {

	// Si la forma de pago no pide propina. Devuelvo propina  a cero
	if (!method.RegisterTip)
		return Result.ok(0);

	// Si el terminal las pide él, aquí tampoco hago nada y devuelvo propina a 0
	if (SessionProvider.deviceAskGratuity())
		return Result.ok(0);

	// Sólo se pide la propina al cliente en teléfonos y tablets.
	const deviceSupportCustomerTipSelection = ThemeManager.isPhone() || ThemeManager.isTablet();
	if (!deviceSupportCustomerTipSelection)
		return Result.ok(0);

	const suggestedTipRates = SessionProvider.getSuggestedTipRates();
	if (!SessionProvider.allowSuggestedTipSettings() || suggestedTipRates.length === 0)
		return Result.ok(0);

	const tipAmountResult = await Modal.show(SelectSuggestedTipAmountScreen, { suggestedTipRates, totalAmount: amountToPay });
	if (!tipAmountResult.ok)
		return Result.error();

	var tipValue = tipAmountResult.value.SuggestedTipAmount;

	if (tipAmountResult.value.IsCustomTipAmount) {
		const customTipAmountResult = await Modal.show(InsertCustomTipAmountScreen);
		if (!customTipAmountResult.ok)
			return Result.error();
		tipValue = customTipAmountResult.value;
	}

	return Result.ok(tipValue);
}